import { Parts } from "components";
import { useParams } from "react-router";

export default function Order(){
    const params = useParams()

    return <Parts.Screens.Order data={{ id: params.id }} />
}